import { createAction, handleActions } from "redux-actions";
import { applyPenders } from "redux-pender";
import produce from "immer";
import * as apis from "../../lib/api/score";

/* ACTION TYPE */
const SET_CUSTOMER_ID = "stamp/SET_CUSTOMER_ID";
const GET_CUSTOMER = "stamp/GET_CUSTOMER";
const GET_STORE = "stamp/GET_STORE";

const getCustomer = async (customerId, owner) => {
  const customer = await apis.getCustomer(customerId, owner);
  return customer;
};

const getStore = async owner => {
  return await apis.getStore(owner);
};

const initialState = {
  store: {},
  cusomerId: "",
  customer: {}
};

export const actionCreators = {
  setCustomerId: createAction(SET_CUSTOMER_ID, value => value),
  getCustomer: createAction(GET_CUSTOMER, getCustomer),
  getStore: createAction(GET_STORE, getStore)
};

const reducer = handleActions(
  {
    [SET_CUSTOMER_ID]: (state, action) => {
      return produce(state, draft => {
        if (!action.payload) return;
        draft.customerId = action.payload;
      });
    }
  },
  initialState
);

export default applyPenders(reducer, [
  {
    type: GET_STORE,
    onSuccess: (state, action) => {
      return produce(state, draft => {
        if (!action.payload) return;
        const store = JSON.parse(action.payload);
        draft.store = store;
      });
    },
    onFailure: state => {
      return produce(state, draft => {
        draft.store = {};
      });
    }
  },
  {
    type: GET_CUSTOMER,
    onSuccess: (state, action) => {
      return produce(state, draft => {
        if (!action.payload) return;
        const customer = JSON.parse(action.payload);
        draft.customer = customer;
      });
    },
    onFailure: state => {
      return produce(state, draft => {
        draft.customer = {};
      });
    }
  }
]);
